import HTTPHandler from 'lib/api/HTTPHandler'
import { NOTIFICATION_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class NotificationService {
  static updateEventSubdivision = async data => {
    try {
      const result = await HTTPHandler.post(
        NOTIFICATION_API_URL + '/events/subdivision',
        data
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }
}
